export default "__VITE_ASSET__f10e4989__"